import React from "react";
import one from './pics/one.jpeg';
import two from './pics/two.jpeg';
import three from './pics/three.jpeg';
import four from './pics/four.jpeg';
import five from './pics/five.jpeg';
import six from './pics/six.jpeg';
import seven from './pics/seven.jpeg';
import eight from './pics/eight.jpeg';
import nine from './pics/nine.jpeg';
import ten from './pics/ten.jpeg';
import eleven from './pics/eleven.jpeg';
import twelve from './pics/twelve.jpeg';
import thirteen from './pics/thirteen.jpeg';
import fourteen from './pics/fourteen.jpeg';
import fifteen from './pics/fifteen.jpeg';
import sixteen from './pics/sixteen.jpeg';
import './Fintiba.css';

class Fintiba extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">
                                    فتح حساب مغلق فى
                                <br/>
                                    “fintiba“ Sutor bank
                                </legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                <div class="row">
                                        <div class="column">
                                            <img alt='' width='300px' height='200px' src={one} />
                                            <img alt='' width='300px' height='200px' src={two} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px' src={three} />
                                            <img alt='' width='300px' height='200px'src={four} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={five} />
                                            <img alt='' width='500px' height='200px'src={six} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={seven} />
                                            <img alt='' width='300px' height='200px'src={eight} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={nine} />
                                            <img alt='' width='300px' height='200px'src={ten} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={eleven} />
                                            <img alt='' width='300px' height='200px'src={twelve} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={thirteen} />
                                            <img alt='' width='300px' height='200px'src={fourteen} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={fifteen} />
                                            <img alt='' width='300px' height='200px'src={sixteen} />
                                        </div>
                                    </div>
                                    <hr/>
                                    <h3>
                                        السلام عليكم .. النهاردة هتكلم على طريقة فتح الحساب البنكى المغلق فى فانتيبا "ستور بنك" و تفعيله عند الوصول لالمانيا
                                        <br/>
                                        sutor bank
                                        <br/>
                                        دة اسم البنك و مقره فى مدينة هامبورج الالمانية
                                        <br/>
                                        و المسئول عن فتح الحساب فهى شركة فنتيبا و مقرها فى فرانكفورت ومن خلالها نقدر نفتح حساب فى ستور بنك
                                        <br/>
                                        و ستور بنك من احد البنوك المعتمدة على موقع السفارة لفتح الحساب المغلق
                                        <br/>
                                        يعنى مش نصب ولا حد هيسرقك
                                        <br/>
                                        اى حد يقدر يفتح حساب مغلق فى البنك دة اذا كان دراسة او بحث عن عمل او لغة او لم شمل
                                        <br/>
                                        عند فتح الحساب فالبنك دة مبيحتجش اى حاجة غير الباسبور
                                        <br/>
                                        يعنى لا هيحتاج قبول جامعة ولا هيحتاج كشف حساب للحساب اللى هتحول منه ولا توثق ورق من السفارة ولا اى حاجة
                                        <br/>
                                        و بعتبره افضل بنك الواحد يفتح فيه لان خطوات فتح الحساب فى مصر سهلة و خطوات تفعيله عند الوصول ل المانيا سهلة جدا
                                        <br/>
                                        مرفق فى البوست طريقة فتح الحساب بالصور و بالترتيب
                                        <br/>
                                        كل اللى عليك ان هتدخل ع <a target='_blank' rel='noreferrer' href='https://www.fintiba.com/#home-offering'>اللينك</a> دة
                                        <br/>
                                        و هتختار بلوكد اكونت و هتعمل اكونت ب ايميلك و هتمشى خطوة خطوة زى ما موجود فالصور و هيبعتوا ليك على الايميل لينك تضغط عليه لتفعيل الايميل زى ما موجود فى صورة رقم
                                        7
                                        <br/>
                                        و بعد كدة هتدخل تكمل البيانات عادى و تقريبا بتاخد من يومين لتلاتة عمل للتأكد من المعلومات
                                        - صورة رقم
                                        5 و 12
                                        <br/>
                                        اختار no
                                        <br/>
                                        لان المصريين معندهمش رقم ضريبى
                                        <br/>
                                        لحد ما هتوصل لخطوة الفيديو كول
                                        <br/>
                                        اللى هى فى صورة رقم
                                        13
                                        <br/>
                                        و الخطوة دى بعد ما تعمل كل الخطوات اللى قبلها
                                        <br/>
                                        و دى اهم خطوة
                                        <br/>
                                        اللى من خلالها هتقدر تعمل خطوة الفيديو كول و دى هتحجز ميعاد وهيعملوا معاك فيديو كول عشان يتأكدوا من المعلومات والباسبور .. الفيديو كول بالانجليزى او الالمانى ع حسب انت عايز ايه و ممكن يكون عربى لو الموظف عربى و انت مبتعرفش تتكلم اللغتين .. و الانترفيو عبارة عن مراجعة بياناتك مش اكتر و حوالى ربع ساعة
                                        <br/>
                                        و هتختار الميعاد و طريقة المكالمة 
                                        <br/>
                                        فهتنزل ابلكيشن اسمه
                                        <br/>
                                        [verify-U] face2face
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://play.google.com/store/apps/details?id=de.cybits.vu.videoident&referrer=phonecode:FN-36581797864'>android</a> ||| <a target='_blank' rel='noreferrer' href='https://apps.apple.com/.../verify-u-video-ident/id1316054117'>IOS</a>
                                        <br/>
                                        و يفضل تكون فاتح من موبايل فيه كاميرا كويسة و جودة النت تكون عالية مش من لاب
                                        <br/>
                                        و ايضا لازم تكون فاتح اللاب لانهم هيبعتوا ايميل اثناء المكالمة ولازم تفتح الايميل و بعد ما المكالمة تنتهى فهيبعتوا ليك بعدها بيومين تلاتة عمل فايل فيه بيانات الحساب بتاعك اللى المفروض تحول عليه الفلوس
                                        <br/>
                                        - فيه اوقات النت بيبقا مش كويس عند بعض الناس و مبيعرفوش يكملوا المكالمة فهتحجز ميعاد تانى لحد ما المكالمة تنتهى اما لو معرفتش تكمل المكالمة بعد عدة محالاوت و قالوا ليك اتواصل مع البنك فكل اللى عليك هتبعت ميل لفنتيبا و هتقولهم انك حاولت اكتر من مرة و معرفتش تكمل المكالمة و ان ميعادك فالسفارة قرب و ان انت عايز تفعل حسابك عشان تحول الفلوس و تدخل الانترفيو و هما هيتفهموا و هيقولوا تعمل ايه
                                        <br/>
                                        كدة انت خلاص فتحت الحساب البنكى فى المانيا و هيبعتوا ليك الفايل اللى فى صورة رقم
                                        16
                                        <br/>
                                        و دى اللى هتروح بيها للبنك اللى هتحول منه لحسابك فى المانيا
                                        <br/>
                                        - قيمة الحساب البنكى حاليا هى
                                        <br/>
                                        €10,332
                                        <br/>
                                        - قيمة فتح الحساب البنكى فى فنتيبا هى
                                        <br/>
                                        €89 يورو
                                        <br/>
                                        - 100 يورو كمان ع المبلغ لان البنك الوسيط و البنك اللى هتحول منه هياخدوا فلوس للتحويل و لو اتبقى فلوس ف الباقى هيبقا فى الحساب
                                        <br/>
                                        التحويل مدته من 4 ل 7 ايام عمل
                                        <br/>
                                        بعد ما تحول الفلوس كاملة لحسابك فى المانيا ف البنك هيبعتلك فايل تانى بيأكدلك ان خلاص الفلوس اتحولت و الفايل دة هتدخل بيه انترفيو السفارة
                                        <br/>
                                        لو انت حولت الفلوس و عايز تقفل الحساب و مش عايز تسافر ف الموضوع بسيط
                                        <br/>
                                        <a href='/closedbankaccount_financialguarantor/refund'>من هنا</a>
                                        <br/>
                                        .....................
                                        <br/>
                                        تفعيل الحساب البنكى فى فنتيبا عند الوصول لالمانيا
                                        <br/>
                                        هتفتح الاكونت بتاعك على موقع فنتيبا و هتسجل البيانات المطلوبة منك ع سبيل المثال
                                        <br/>
                                        - تحميل صورة الفيزا الخاصة بيك
                                        <br/>
                                        - عنوانك فى المانيا
                                        <br/>
                                        لو انت قاعد فى هوستيل او عند صحبك ف اكتب العنوان اللى انت ساكن فيه
                                        <br/>
                                        - رقم تليفونك فى المانيا
                                        <br/>
                                        - رقم الحساب الجارى اللى فنتيبا هتحول عليه الفلوس
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='/closedbankaccount_financialguarantor/bestbank'>و بوست عن افضل بنك</a>
                                        <br/>
                                        ............
                                        <br/>
                                        - فيه بعض الناس مبتبقاش عملت خطوة الفيديو كول و هى فى مصر ف ممكن يتطلب منها لما توصل المانيا عشان يتأكدوا من المعلومات
                                        <br/>
                                        - ممكن فنتيبا يطلب منك عقد سكن و دة نادرا لما يطلب عقد سكن و انملدونج .. بس ليها حل و اكتر من صديق عمله .. ان هو هيبعت ميل لفنتيبا و هيقولهم ان انا لسا جاى المانيا ومش لاقى سكن و لازم الحساب يتفعل عشان اقدر ادفع فلوس السكن و برضه فنتيبا بيقدروا النقطة دى و حولوا ليهم الفلوس من غير عقد سكن.
                                        <br/>
                                        .........
                                        بعد ما هتملى البيانات المطلوبة منك فالفلوس هتتحول فى خلال يومين تلاتة عمل على حسابك الجارى اللى انت فتحته فى المانيا
                                        <br/>
                                        - كل شهر هيتم تحويل
                                        <br/>
                                        €861
                                        <br/>
                                        لان فنتيبا هتخصم
                                        <br/>
                                        €4.90 يورو فالشهر كخدمة ليها لانها شركة وليس بنك
                                        <br/>
                                        يعنى اجمالى فتح الحساب فى فنتيبا هيكلفك
                                        <br/>
                                        €150 يورو فالسنة زى اى بنك تانى عادى
                                        <br/>
                                        ...
                                        <br/>
                                        تعديل .. ان الحساب البنكى زاد فالمبلغ اللى هتفتح بيه الحساب فهيبقا اكتر و الفلوس اللى هتجيلك هتبقا اكتر من اللى فوق
                                        <br/>
                                        بس عموما الخطوات هى هى مفيش جديد
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default Fintiba;
